interface ChipGroupProps {
  items: string[];
  value?: string | null;
  onSelect: (item: string) => void;
  className?: string;
}

export default function ChipGroup({ items, value, onSelect, className = '' }: ChipGroupProps) {
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {items.map((item) => {
        const active = value === item;
        return (
          <button
            key={item}
            type="button"
            onClick={() => onSelect(item)}
            className={`px-3 py-1.5 rounded-full text-xs border transition-colors cursor-pointer ${
              active
                ? 'bg-navy text-white border-navy'
                : 'bg-white text-navy-light border-cream-dark hover:border-beige'
            }`}
          >
            {item}
          </button>
        );
      })}
    </div>
  );
}
